export default __webpack_public_path__ + "static/media/plain-sticker-r.0ac23456.png";